import { Component, OnInit } from '@angular/core';
import { IPagination, IDynamicTableColumn } from '../../../../shared/interfaces';
import {
  DialogImportComponent,
  DialogConfig,
} from '../../components/dialog-import/dialog-import.component';
import { MatDialog } from '@angular/material/dialog';
import { LmrServices } from '../../services/lmr.service';
import Utils from '@app/shared/utils/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-head-office',
  templateUrl: './head-office.component.html',
  styleUrls: ['./head-office.component.sass'],
})
export class HeadOfficeComponent implements OnInit {
  headerTitle = 'Matriz LMR';
  headerSubtitle =
    'Visualize um resumo de todas as margens máximas de gasto e preços dos produtos cadastrados.';

  tableColumns: IDynamicTableColumn[] = [
    {
      columnDef: 'modelo',
      header: 'Modelo',
      warningIcon: {
        conditionField: 'noRepair',
        icon: 'warning',
        tooltip: 'Este produto não possui reparo e não participa do cálculo do LMR.',
      },
    },
    { columnDef: 'modeloCompleto', header: 'Modelo Completo' },
    { columnDef: 'bat70', header: 'BAT70' },
    { columnDef: 'batMenor70', header: 'BAT<70' },
    { columnDef: 'outlet', header: 'Outlet' },
    { columnDef: 'recGradeA', header: 'Rec. Grade A' },
    { columnDef: 'recGradeB', header: 'Rec. Grade B' },
    { columnDef: 'recDisplay', header: 'Rec. Display' },
    { columnDef: 'reparoInviavel', header: 'Reparo Inviável' },
    { columnDef: 'garantia', header: 'Garantia' },
  ];

  tableData: any[] = [];
  loaded = false;
  searchTerm: string = '';

  pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  };

  selectedManufacturers: string[] = [];

  constructor(
    private dialog: MatDialog,
    private lmrServices: LmrServices,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadMatrizData();
  }

  loadMatrizData(): void {
    this.lmrServices
      .listMatriz({
        filtro: this.buildFiltro(),
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      })
      .subscribe({
        next: (response) => {
          this.tableData = response.page.map((item: any) => ({
            modelo: item.modelo ?? '-',
            noRepair: item.isRepairLmr === false,
            modeloCompleto: item.modeloCompleto ?? '-',
            bat70: this.formatCurrency(item.bat70),
            batMenor70: this.formatCurrency(item.batMenor70),
            outlet: this.formatCurrency(item.outlet),
            recGradeA: this.formatCurrency(item.recGradeA),
            recGradeB: this.formatCurrency(item.recGradeB),
            recDisplay: this.formatCurrency(item.recDisplay),
            reparoInviavel: this.formatCurrency(item.reparoInviavel),
            garantia: this.formatCurrency(item.garantia),
          }));

          this.pagination = {
            currentPage: response.currentPage,
            pageSize: response.pageSize,
            totalItems: response.count,
          };
          this.loaded = true;
        },
        error: (error) => {
          console.error('Erro na API:', error);
          this.loaded = true;
        },
      });
  }
  formatCurrency(value: any): string {
    if (value === null || value === undefined) {
      return '-';
    }

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  }

  onSearchChange(value: string): void {
    if (value === '') {
      this.onSearch();
    }
  }

  onSearch(): void {
    this.loadMatrizData();
  }

  onFilterChange(event: any): void {
    this.selectedManufacturers = event.value;
    this.loadMatrizData();
  }

  openImportDialog(): void {
    const dialogRef = this.dialog.open(DialogImportComponent, {
      width: '900px',
      maxWidth: '95vw',
      panelClass: 'custom-mat-dialog',
      autoFocus: false,
      data: {
        mode: 'simple',
        textDialog:
          'Para importar a tabela, selecione o arquivo base com as informações de matriz LMR, em seguida, clique em “Importar”.',
        importFn: (file: File) => this.lmrServices.importMatriz(file),
      } as DialogConfig,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadMatrizData();
      }
    });
  }

  onPageChange(event: any): void {
    this.pagination.currentPage = event.currentPage;
    this.pagination.pageSize = event.pageSize;
    this.loadMatrizData();
  }

  downloadTemplate(): void {
    const fileName = `Modelo_Template_Importacao_Matriz_LMR`;
    this.lmrServices.templateMatriz().subscribe({
      next: (data) => {
        Utils.createAndDownloadBlobFile(data, fileName, 'xlsx');
      },
      error: (err) => {
        const { errors } = Utils.arrayBufferToJson(err);
        this.toastr.error(errors || 'Ocorreu um erro ao exportar, tente novamente mais tarde.');
      },
    });
  }

  buildFiltro(): string {
    const filtros: string[] = [];

    if (this.searchTerm?.trim()) {
      filtros.push(this.searchTerm.trim());
    }

    if (this.selectedManufacturers?.length) {
      filtros.push(
        this.selectedManufacturers
          .map((m) => m.trim())
          .filter(Boolean)
          .join(',')
      );
    }

    return filtros.join('|');
  }
}
